import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Dedicated client for the EXTERNAL vendor portal — uses its own token store
// (`reason_vendor_token`) so it never collides with internal staff auth.
export const portalApi = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: { "Content-Type": "application/json" },
});

portalApi.interceptors.request.use((cfg) => {
  const tok = localStorage.getItem("reason_vendor_token");
  if (tok) cfg.headers.Authorization = `Bearer ${tok}`;
  return cfg;
});
